import React from 'react';
import { Languages } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageToggle = ({ className = "", variant = "default" }) => {
  const { language, toggleLanguage, isArabic } = useLanguage();
  
  if (variant === "selector") {
    return (
      <div className={`flex items-center gap-2 ${className}`}>
        <Languages className="w-4 h-4 text-gray-400" />
        <select
          value={language}
          onChange={(e) => toggleLanguage()}
          className="bg-gray-800 border border-gray-600 rounded px-2 py-1 text-sm text-white focus:border-blue-400 focus:outline-none"
        >
          <option value="en">English</option>
          <option value="ar">العربية</option>
        </select>
      </div>
    );
  }
  
  if (variant === "button") {
    return (
      <button
        onClick={toggleLanguage}
        className={`
          flex items-center gap-2 px-3 py-2 rounded-lg
          bg-gray-100 hover:bg-gray-200 text-gray-700
          transition-colors duration-200
          ${className}
        `}
        title={isArabic ? "Switch to English" : "التبديل إلى العربية"}
      >
        <Languages className="w-4 h-4" />
        <span className="text-sm font-medium">
          {isArabic ? "EN" : "عربي"}
        </span>
      </button>
    );
  }
  
  // Default toggle for dark themes
  return (
    <button
      onClick={toggleLanguage}
      className={`
        flex items-center gap-2 px-3 py-1.5 rounded-full
        bg-white/10 hover:bg-white/20 text-white/80 hover:text-white
        border border-white/20 hover:border-white/30
        transition-all duration-200
        ${className}
      `}
      title={isArabic ? "Switch to English" : "التبديل إلى العربية"}
    >
      <Languages className="w-4 h-4" />
      <span className="text-sm">
        {isArabic ? "EN" : "عر"}
      </span>
    </button>
  );
};

export default LanguageToggle;